import Point from '../../Utility/Point';
import GameObject from '../../GameObject/GameObject';
import Sprite from '../Sprite';
import Container from '../Container';
import Interactable from '../../Component/Interactable';
import TransformComponent from '../../Component/Transform';
import AnimationComponent from '../../Component/Animation';
import Renderable from '../../Component/Renderable';
import Game from 'Game';

export default class PlayerIcon extends GameObject {
    private elapsed: number;

    public onCreate(params: { avatarTexture: string; isClientPlayer: boolean; name?: string }): void {
        if (params.name) {
            this.name = params.name;
        }

        this.addComponent<TransformComponent>(TransformComponent, params);
        this.addComponent<Renderable>(Renderable);
        this.addComponent<Interactable>(Interactable, { buttonMode: true });

        const pivot: Point = new Point(0, 18);

        const iconContainer = GameObject.Instantiate(Container, {
            pivot,
        });

        this.addChild(iconContainer);
        const avatarSprite = GameObject.Instantiate(Sprite, {
            position: new Point(0, -87),
            texture: Game.player.getAvatarTexture(),
            anchor: new Point(0.5, 1),
            width: 73,
            height: 73,
        });
        iconContainer.addChild(avatarSprite);

        const iconSprite = GameObject.Instantiate(Sprite, {
            texture: 'avatar_shadowless',
            anchor: new Point(0.5, 1),
        });

        iconContainer.addChild(iconSprite);

        iconContainer.addComponent(AnimationComponent, {
            playOnStart: true,
            clipName: 'PlayerIconIdle',
        });
    }
}
